import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  useListarFilaRoletaCheckin,
  type FilaProps,
} from "services/api/AppWeb_Checkin/listar_roletaaovivo";
import { v4 as uuidv4 } from "uuid";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import * as S from "./styles";
import PDVInfo from "./components/PDVInfo";
import FirstOnQueue from "./components/FirstOnQueue";
import Queue from "./components/Queue";
import NavCommon from "../../components/@navHeader";

const UPDATE_TIME = 10;

const RoletaAoVivo: React.FC = () => {
  const { id }: any = useParams();
  const history = useHistory();
  const {
    data: dataListaRoletaAovivo,
    refetch: refetchListaRoletaAovivo,
    isFetching: isFetchingListaRoletaAoVivo,
  } = useListarFilaRoletaCheckin({
    queryKey: `fila_roleta_checkin_${id}`,
    idRoletaCheckin: id,
  });

  const user = useSelector<RootStateOrAny, AuthState>((state) => state.user);

  const isRecepcionista = user?.codigoCargo2013 === "219.840.007";

  const filaAtivo = dataListaRoletaAovivo?.fila.some(
    (item: FilaProps) => item?.posicao !== 1 && item?.ativo === true
  );
  const primeiraPosicaoAtivo = dataListaRoletaAovivo?.fila.some(
    (item: FilaProps) => item?.posicao === 1 && item?.ativo === true
  );

  return (
    <>
      <NavCommon
        breadcrumbs={
          isRecepcionista
            ? [
                { path: "/roleta", name: "Roleta" },
                { path: `/roleta-ao-vivo/${id}`, name: "Roleta ao vivo" },
              ]
            : [
                { path: "/checkin", name: "Checkin" },
                { path: `/roleta-ao-vivo/${id}`, name: "Roleta ao vivo" },
              ]
        }
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Container>
        {dataListaRoletaAovivo ? (
          <>
            <PDVInfo data={dataListaRoletaAovivo} />
            {primeiraPosicaoAtivo ? (
              <FirstOnQueue data={dataListaRoletaAovivo} />
            ) : null}
            {filaAtivo ? <Queue data={dataListaRoletaAovivo} /> : null}
          </>
        ) : null}
      </S.Container>
    </>
  );
};

export default RoletaAoVivo;
